import Phaser from "phaser";

const STORAGE_KEY = "llo_sfx_enabled";
const REGISTRY_KEY = "sfxEnabled";

/** Ensure the registry has a value (defaults to true, persisted in localStorage). */
export function initSfxEnabled(scene: Phaser.Scene): void {
  const existing = scene.registry.get(REGISTRY_KEY);
  if (typeof existing === "boolean") return;

  let enabled = true;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === "0") enabled = false;
    if (raw === "1") enabled = true;
  } catch {
    // ignore
  }

  scene.registry.set(REGISTRY_KEY, enabled);
}

export function getSfxEnabled(scene: Phaser.Scene): boolean {
  const v = scene.registry.get(REGISTRY_KEY);
  return typeof v === "boolean" ? v : true;
}

export function setSfxEnabled(scene: Phaser.Scene, enabled: boolean): void {
  scene.registry.set(REGISTRY_KEY, enabled);
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? "1" : "0");
  } catch {
    // ignore
  }
}
